import React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { FlattenedError, focusField } from "../fieldLabelMap";
import "./MissingFieldsSummary.css";

interface MissingFieldsSummaryProps {
  errors: FlattenedError[];
  /** Formulario dueño de estos errores: limita la búsqueda del campo a esta pestaña. */
  scopeRef: React.RefObject<HTMLElement>;
}

const MissingFieldsSummary: React.FC<MissingFieldsSummaryProps> = ({ errors, scopeRef }) => {
  if (errors.length === 0) return null;

  return (
    <div className="missingFieldsSummaryContainer">
      <div className="missingFieldsSummaryHeader">
        <ErrorOutlineIcon className="missingFieldsSummaryIcon" />
        <span className="missingFieldsSummaryTitle">
          Campos obligatorios faltantes ({errors.length})
        </span>
      </div>
      <p className="missingFieldsSummaryDescription">
        Por favor completa los siguientes campos antes de enviar el formulario:
      </p>
      <ul className="missingFieldsSummaryList">
        {errors.map((err) => (
          <li key={err.name} className="missingFieldsSummaryItem">
            <button
              type="button"
              className="missingFieldsSummaryLink"
              onClick={() => focusField(err.name, scopeRef.current)}
            >
              {err.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MissingFieldsSummary;
